// extracted by mini-css-extract-plugin
export default {"selectorContainer":"VoiceSelector_selectorContainer__ddUdJ"};